<template>
  <div id="rightData">
    <div class="top">
      <div class="item" v-for="(item, index) in textmain" :key="index">
        <div class="img">
          <img :src="item.imgUrl" alt="" />
        </div>
        <div class="text">
          <span>{{ item.title }}</span>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <RightPancake1 :chart="main1"></RightPancake1>
      <RightPancake2 :chart="main2"></RightPancake2>
      <RightPancake3 :chart="main3"></RightPancake3>
      <RightPancake4 :chart="main4"></RightPancake4>
    </div>
  </div>
</template>

<script>
  import RightPancake1 from './pancake/_rightPancake1.vue';
  import RightPancake2 from './pancake/_rightPancake1 copy.vue';
  import RightPancake3 from './pancake/_rightPancake1 copy 2.vue';
  import RightPancake4 from './pancake/_rightPancake1 copy 3.vue';

  export default {
    components: {
      RightPancake1,
      RightPancake2,
      RightPancake3,
      RightPancake4
    },
    data() {
      return {
        textmain: [
          { imgUrl: require('@/main/assets/DSJimg/vip.png'), title: '会员总计', text: '0' },
          { imgUrl: require('@/main/assets/DSJimg/geren.png'), title: '个人总计', text: '0' },
          { imgUrl: require('@/main/assets/DSJimg/company.png'), title: '企业总计', text: '0' },
          { imgUrl: require('@/main/assets/DSJimg/jigou.png'), title: '机构总计', text: '0' },
          { imgUrl: require('@/main/assets/DSJimg/news.png'), title: '资讯总计', text: '0' },
          { imgUrl: require('@/main/assets/DSJimg/need.png'), title: '需求总计', text: '0' },
          { imgUrl: require('@/main/assets/DSJimg/xuqiucaigou.png'), title: '采购总计', text: '0' },
          { imgUrl: require('@/main/assets/DSJimg/chongzhi.png'), title: '充值总计', text: '0' }
        ],
        main1: {
          title: '用户占比（未认证、个人、企业、机构）',
          idName: 'main1'
        },
        main2: {
          title: '需求占比（发布、采购）',
          idName: 'main2'
        },
        main3: {
          title: '支付占比（微信、支付宝、汇款）',
          idName: 'main3'
        },
        main4: {
          title: '发布需求占比（成交、未成交）',
          idName: 'main4'
        }
      };
    },
    mounted() {
      // httpKit.post($api_eap.user.get).then(res => {
      //   if (res.data.code === '200') {
      //     this.textmain[0].text = res.data.data.memberTotalCount;
      //     this.textmain[1].text = res.data.data.personalMemberTotalCount;
      //     this.textmain[2].text = res.data.data.companyMemberTotalCount;
      //     this.textmain[3].text = res.data.data.organizationMemberTotalCount;
      //     this.textmain[4].text = res.data.data.newsCount;
      //     this.textmain[5].text = res.data.data.demandCount;
      //     this.textmain[6].text = res.data.data.purchaseCount;
      //     this.textmain[7].text = res.data.data.totalRecharge;
      //   }
      // });
    }
  };
</script>

<style lang='less' scoped>
  #rightData {
    .top {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      width: 100%;

      .item {
        width: calc((100% - 100px) / 4);
        border-radius: 10px;
        height: 140px;
        background: #ffffff;
        display: flex;
        align-items: center;
        margin: 10px 0;
        // justify-content: space-around;

        .img {
          width: 94px;
          height: 94px;
          margin-left: 23px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text {
          box-sizing: border-box;
          height: 94px;
          height: 94px;
          margin-left: 20px;
          padding: 10px 0;
          span {
            color: #999999;
            font-size: 20px;
          }
          p {
            color: #333333;
            font-size: 28px;
          }
        }
      }
    }
    .bottom {
      display: flex;
      justify-content: space-evenly;
      width: 100%;
    }
  }
</style>
